import type { FreightClassConfig, IGetRateItem } from '@features/Rate/types/GetRateTypes';
import type { GetRateState } from '@/store/slices/Rate.slice';

export const COUNTRY_CODES = [
  { value: 'USA', label: 'USA' },
  { value: 'CANADA', label: 'CANADA' },
  { value: 'MEXICO', label: 'MEXICO' },
  { value: 'PUERTO RICO', label: 'PUERTO RICO' },
];

export const FREIGHT_CLASS_CONFIG: FreightClassConfig[] = [
  { freight_class_code: 50, min_weight: 50, max_weight: null },
  { freight_class_code: 55, min_weight: 35, max_weight: 50 },
  { freight_class_code: 60, min_weight: 30, max_weight: 35 },
  { freight_class_code: 65, min_weight: 22.5, max_weight: 30 },
  { freight_class_code: 70, min_weight: 15, max_weight: 22.5 },
  { freight_class_code: 77.5, min_weight: 13.5, max_weight: 15 },
  { freight_class_code: 85, min_weight: 12, max_weight: 13.5 },
  { freight_class_code: 92.5, min_weight: 10.5, max_weight: 12 },
  { freight_class_code: 100, min_weight: 9, max_weight: 10.5 },
  { freight_class_code: 110, min_weight: 8, max_weight: 9 },
  { freight_class_code: 125, min_weight: 7, max_weight: 8 },
  { freight_class_code: 150, min_weight: 6, max_weight: 7 },
  { freight_class_code: 175, min_weight: 5, max_weight: 6 },
  { freight_class_code: 200, min_weight: 4, max_weight: 5 },
  { freight_class_code: 250, min_weight: 3, max_weight: 4 },
  { freight_class_code: 300, min_weight: 2, max_weight: 3 },
  { freight_class_code: 400, min_weight: 1, max_weight: 2 },
  { freight_class_code: 500, min_weight: 0, max_weight: 1 },
];

export const initialItem = (): IGetRateItem => ({
  id: `item-${Date.now()}`,
  quantity: 0,
  length: 0,
  width: 0,
  height: 0,
  weight: 0,
  stackable: false,
  notTurnable: false,
  layers: '2',
});

export const initialState: GetRateState = {
  form: {
    shipmentReadyDate: '',
    shipmentMode: '',
    originZipCode: '',
    destinationZipCode: '',
    shipmentType: 'dry',
    ratingType: 'handling_units',
    items: [initialItem()],
    additionalServices: [],
    freightClassLength: '',
    freightClassShippingWeight: '',
    linearFootLength: '',
    linearFootShippingWeight: '',
    countryCode: 'USA',
  },
  quoteSummary: {
    totalItems: 0,
    totalWeight: 0,
    totalCubic: 0,
    averageDensity: 0,
    shipmentType: 'Dry Product',
    ratingType: 'Handling Units',
  },
  originZipCode: null,
  destinationZipCode: null,
  loading: false,
  error: null,
  errors: {},
  currentStep: 1,
  rateResponse: null,
  trailer3DItems: [],
};
